import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { RoutletNames } from '@common/types/types';

@Component({
    selector: 'aa-routlets',
    templateUrl: './routlets.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoutletsComponent
{
    @Input() names: RoutletNames = [];
}
